import { Pipe, PipeTransform } from '@angular/core';
import { Address, JobUtility } from '@jms/model';

@Pipe({
  name: 'addressTwoLines',
  standalone: true
})
export class AddressTwoLinesPipe implements PipeTransform {

  transform(address: Address): string {

    let address1 = JobUtility.getAddress1(address);
    address1 = !address1 || address1 === '' ? 'Not Set' : address1;

    let address2 = JobUtility.getAddress2(address);

    address2 = !address2 || address2 === '' ? 'Not Set' : address2;

    return `${address1} <br> ${address2}`;
  }

}
